import React, { useState } from "react";
import { IconContext } from "react-icons";
import { FaRegFileAudio } from "react-icons/fa";
import { domain } from "./../../../../../global/domain";
import { iconsColor } from "./../../../../../global/iconsColor";

const PreviewAudio = ({ file, deleteOne }) => {
  return (
    <div className="flex flex-col items-center space-y-2 md:text-xs 2xl:text-lg cursor-pointer">
      <div>
        <IconContext.Provider
          value={{ size: "8em", style: { color: iconsColor } }}>
          <FaRegFileAudio></FaRegFileAudio>
        </IconContext.Provider>

        <p className="text-center break-all">
          {file.uploaded_audio.replace(`http://${domain}/media/audios/`, "")}
        </p>
      </div>
    </div>
  );
};

export default PreviewAudio;
